import axios from "axios";
import { ApiUrl } from "./ApiUrl";

export const CheckIdBooking = (BookingId: string, EmailAddress: string) => {
  return axios
    .request({
      method: "GET",
      url: `${ApiUrl}/bookings/CheckBookingCode`,
      params: {
        BookingCode: BookingId,
        Email: EmailAddress,
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      return "NotFound";
    });
};
